/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_Nav_ProductInputs */

const en_gc_home_nav_product = /** @type {(inputs: Gc_Home_Nav_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The workspace`)
};

const zh_gc_home_nav_product = /** @type {(inputs: Gc_Home_Nav_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`产品介绍`)
};

/**
* | output |
* | --- |
* | "The workspace" |
*
* @param {Gc_Home_Nav_ProductInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_nav_product = /** @type {((inputs?: Gc_Home_Nav_ProductInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_Nav_ProductInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_nav_product(inputs)
	return zh_gc_home_nav_product(inputs)
});
export { gc_home_nav_product as "gc.home.nav.product" }